import {
  enhanceWrapped,
  InputBase,
} from '../../../../../configure/components/InputBase';

const INPUT_LABEL = 'Unsubscribe Button text';
const INPUT_PLACEHOLDER = '⛔️ Yes';
const FIELD_TO_UPDATE = 'unsubscribeButtonText';

const enhance = enhanceWrapped(FIELD_TO_UPDATE, INPUT_LABEL, INPUT_PLACEHOLDER);
const UnsubscribeButtonText = enhance(InputBase);

export default UnsubscribeButtonText;
